import * as angular from 'angular';

import { BugsnagHelpers } from '../../../../../lib/bugsnag-helpers';
import { getOwnerUsername } from '@mode/shared/util-js';
import { ModalService } from '@mode/shared/ui-angularjs';
import { QueryOptions } from '@mode/shared/data-access-algolia';

class GroupAddMembershipModalController {
  public groupToken: string;
  private $close: () => void;
  private algoliaConfig: QueryOptions<'user'>;
  public membershipCallsHaveSucceeded: boolean | null = null; // true if calls 200, false if calls fail, null if not yet sent
  public showSpinner = false;

  static $inject = ['$stateParams', 'GroupMembershipModel', 'AccountModel'];
  constructor(
    private $stateParams,
    private GroupMembershipModel,
    private AccountModel
  ) {
    this.groupToken = $stateParams.groupToken;
    this.setAlgoiliaConfig();
  }

  getOrganization() {
    return this.AccountModel.find({
      username: getOwnerUsername(window.document),
      useEntryPath: true,
    });
  }

  getAlgoliaConfig(org) {
    const orgToken = org.token;
    return {
      indexes: ['user'],
      rawResults: true,
      perPage: 10,
      filters: {
        // only return users who are part of the org, and not already in the group
        user: `organization_${orgToken},-group_${this.groupToken}`,
      },
    };
  }

  setAlgoiliaConfig() {
    this.getOrganization()
      .then((org) => this.getAlgoliaConfig(org))
      .then((algoliaConfig) => {
        this.algoliaConfig = algoliaConfig;
      });
  }

  createMembershipForGroup(userToken) {
    return this.GroupMembershipModel.create({
      group: this.groupToken,
      params: {
        'membership.member_token': userToken,
        includes: ['member'],
      },
    });
  }

  submitMembershipRequests(userTokens) {
    const membershipRequests = userTokens.map((userToken) => this.createMembershipForGroup(userToken));
    this.showSpinner = true;
    Promise.all(membershipRequests)
      .then((res) => {
        this.showSpinner = false;
        this.membershipCallsHaveSucceeded = true;
        console.info(res);
      })
      .catch((err) => {
        this.showSpinner = false;
        this.membershipCallsHaveSucceeded = false;
        BugsnagHelpers.notifySafely(err);
        console.error(err);
      });
  }

  handleConfirm($selectedList) {
    const selectedUserTokens = $selectedList.map((selectedUser) => selectedUser.token);
    this.submitMembershipRequests(selectedUserTokens);
  }

  handleCancel() {
    this.$close();
  }
}

class GroupAddMembership {
  restrict: any;
  static $inject = ['ModalService'];
  constructor(private Modal: ModalService) {
    'ngInject';
    this.restrict = 'A';
  }
  link($scope, $element) {
    $element.on('click.context', () => {
      this.Modal.open(
        {},
        {
          controller: GroupAddMembershipModalController,
          controllerAs: 'ctrl',
          bindToController: true,
          template: `
          <div class="group-add-membership-modal">
            <mode-legacy-dialog-header (closed)="$dismiss()">
              Add Group Members
            </mode-legacy-dialog-header>
            <div class="modal-body with-custom-padding">
              <search-selector
                ng-if="ctrl.membershipCallsHaveSucceeded === null && !ctrl.showSpinner"
                algolia-config="ctrl.algoliaConfig"
                on-confirm="ctrl.handleConfirm($selectedList)"
                on-cancel="ctrl.handleCancel()"
                empty-selected-state-text="Users you've selected to add to this group will appear here."
                confirm-button-text="Add group members"
              >
              </search-selector>

              <!-- Start Loading Spinner -->
              <div
                class="loading-screen"
                ng-if="ctrl.membershipCallsHaveSucceeded === null && ctrl.showSpinner"
              >
                <mode-loader type="tertiary"></mode-loader>
              </div>
              <!-- END Loading Spinner -->

              <!-- Start Success Screen -->
              <div
                class="succeeded-to-create-memberships"
                ng-if="ctrl.membershipCallsHaveSucceeded === true"
                data-test="members-added-successfully"
              >
                <span class="icon-success-checked-circle icon"></span>
                <strong>Users have been successfully added to the group!</strong>
                <strong>It may take a moment for the list of group members to update</strong>
              </div>
              <!-- END Success Screen -->

              <!-- Start Fail Screen -->
              <div
                class="failed-to-create-memberships"
                ng-if="ctrl.membershipCallsHaveSucceeded === false"
              >
                <span class="icon-warning icon"></span>
                <strong>Something went wrong.</strong>
                <strong>You'll need to add those group members again.</strong>
              </div>
              <!-- END Fail Screen -->
            </div>
          </div>
        `,
        }
      );
    });

    $scope.$on('$destroy', () => $element.off('click.context'));
  }
}

export default GroupAddMembership;
